<template>
  <div class="login-wrap">
    <div class="login-card">
      <div class="login-brand">
        <img src="/svqt_images/logo/logo.png" alt="SVQT" onerror="this.style.display='none'" />
        <h1>SVQT Admin</h1>
        <p>Boshqaruv paneliga kirish</p>
      </div>

      <form @submit.prevent="onLogin">
        <div class="mb-3">
          <label class="form-label">Telefon</label>
          <div class="input-icon">
            <i class="bi bi-telephone"></i>
            <input
              type="text"
              class="form-control"
              placeholder="998901234567"
              v-model="phone"
              autocomplete="username"
            />
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Parol</label>
          <div class="input-icon">
            <i class="bi bi-lock"></i>
            <input
              :type="showPass ? 'text' : 'password'"
              class="form-control"
              placeholder="Parol"
              v-model="password"
              autocomplete="current-password"
            />
            <button type="button" class="toggle-pass" @click="showPass = !showPass">
              <i class="bi" :class="showPass ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
        </div>

        <p v-if="error" class="text-danger small mb-3">{{ error }}</p>

        <button class="btn btn-brand w-100 py-2" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          Kirish
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { login } from "../services/auth";
import { useToast } from "../composables/useToast";

const router = useRouter();
const toast = useToast();

const phone = ref("");
const password = ref("");
const showPass = ref(false);
const loading = ref(false);
const error = ref("");

async function onLogin() {
  error.value = "";
  if (!phone.value || !password.value) {
    error.value = "Telefon va parolni kiriting";
    return;
  }
  loading.value = true;
  try {
    await login(phone.value, password.value);
    toast.success("Xush kelibsiz!");
    router.push({ name: "home" });
  } catch (e) {
    if (e?.response) {
      // Server javob berdi (masalan 401) — odatda parol xato
      error.value = e.response.data?.message || "Login yoki parol xato";
    } else {
      // Server javob bermadi — backend ishlamayapti yoki API manzili noto'g'ri
      error.value =
        "Serverga ulanib bo'lmadi. Backend ishlayotganini va API manzilini tekshiring.";
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.login-wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #1e293b, #0f172a);
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 18px;
  padding: 36px 32px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
}
.login-brand {
  text-align: center;
  margin-bottom: 26px;
}
.login-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 10px;
}
.login-brand h1 {
  font-size: 24px;
  font-weight: 800;
  margin: 0;
  color: #1e293b;
}
.login-brand p {
  color: #64748b;
  font-size: 14px;
  margin: 4px 0 0;
}
.input-icon {
  position: relative;
}
.input-icon > i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}
.input-icon .form-control {
  padding-left: 40px;
  height: 46px;
}
.toggle-pass {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
}
.btn-brand {
  background: #bd8d4c;
  border-color: #bd8d4c;
  color: #fff;
  font-weight: 600;
}
.btn-brand:hover {
  background: #a3773a;
  color: #fff;
}
</style>
